import React from 'react';
import GameQuery from '../../query/GameQuery';
import Results from '../../components/Results';
import { Route } from 'react-router-dom';
import { RESULTS } from '../../routes';

const ResultsRoute = () =>
	<GameQuery>
		{({ game }) =>
			<Route
				path={RESULTS}
				render={props => <Results {...props} game={game} />}
			/>
		}
	</GameQuery>
;

export default ResultsRoute;
